(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/verify-selected-charities.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/verify-selected-charities.js');

'use strict';

const STATUS_ACTIVE = 1;
const {
  logger
} = svs.tur.pay_lyckoplatsen;
const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
async function verifySelectedCharities(_ref) {
  let {
    next,
    wagers
  } = _ref;
  const charityIds = new Set();
  wagers.forEach(wager => {
    const charityId = wager.charityId;
    if (charityId) {
      charityIds.add(charityId);
    }
  });
  if (charityIds.size) {
    try {
      const charities = await Promise.all(Array.from(charityIds).map(charityId => drawgamesApiCaller.getCharityExternalcharitiesById({
        charityId
      })));
      wagers.forEach(wager => {
        const charity = charities.find(data => data.response.charity.charityId === wager.charityId);
        if (charity) {
          wager.wasInvalidCharity = charity.response.charity.status !== STATUS_ACTIVE;
        }
      });
    } catch (error) {
      logger.error("Error fetching charities with ids: ".concat(Array.from(charityIds).join(',')), error);
    }
  }
  next({
    wagers
  });
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  verifySelectedCharities
});

 })(window);